import * as React from "react";
import { colors } from "@aifi-ml/design-system-variables";

interface ReceiptNotFoundIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const ReceiptNotFoundIcon: React.FC<ReceiptNotFoundIconProps> = ({
  color = colors.light["color/text/general/secondary"],
  width = 40,
  height = 40,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M6.25 10H33.75M6.25 20H17.5M6.25 30H20M32.2859 26.0359L36.25 30M33.75 22.5C33.75 25.2614 31.5114 27.5 28.75 27.5C25.9886 27.5 23.75 25.2614 23.75 22.5C23.75 19.7386 25.9886 17.5 28.75 17.5C31.5114 17.5 33.75 19.7386 33.75 22.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
